import { getYearMonthSchema } from '../../../schema-utils'

export const rentPaymentReconciliationQueryParams = getYearMonthSchema('month')
